// extracted by mini-css-extract-plugin
export default {"infoLabel":"MriStatus_infoLabel__jrX00","mristatus":"MriStatus_mristatus__bmTAG","required":"MriStatus_required__rlKhh"};